<template>
  <Timeline
    :title="$t('nav.bookmarks')"
    :timeline="timeline"
    :timeline-name="'bookmarks'"
  />
</template>

<script src="./bookmark_timeline.js"></script>
